<template>
    <v-data-table
            :headers="headers"
            :items="projects"
            :search="search"
            :loading="loading"
    >
        <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.displayName }}</td>
            <td class="text-xs-left">{{ $t(`projects.types.${props.item.type}`) }}</td>
        </template>
    </v-data-table>
</template>

<script>
    export default {
        name: "FirebaseProjectTable",
        props: {
            search: {
                type: String,
            },
            projects: {
                type: Array,
                required: true,
            },
            loading: {
                type: Boolean,
                required: true,
            }
        },
        data() {
            return {
                headers:  [
                    { text: this.$t('projects.displayName'), value: 'displayName' },
                    { text: this.$t('projects.types.label'), value: 'type' }
                ]
            }
        }
    }
</script>
